import { useQuery, useMutation } from "react-query";

import {
  activateOnboardingUser,
  inviteOnboardingUser,
  getOnboardingUser,
  searchOnboardingUser,
} from "../../api/Onboarding/onboarding-users";

// Self service - activate user
const useActivateOnboardingUser = (options = {}) => {
  return useMutation(activateOnboardingUser, options);
};

// Self service - resend invite user
const useInviteOnboardingUser = (options = {}) => {
  return useMutation(inviteOnboardingUser, options);
};

const useGetOnboardingUser = (id, searchParams = {}, options = {}) => {
  const records = useQuery(
    ["getOnboardingUser", id, searchParams],
    () => getOnboardingUser(id, searchParams),
    options,
  );
  return records;
};

const useSearchOnboardingUser = (searchParams = {}, options = {}) => {
  const records = useQuery(
    ["searchOnboardingUser",  searchParams],
    () => searchOnboardingUser(searchParams),
    options,
  );
  return records;
};

export {
  useActivateOnboardingUser,
  useInviteOnboardingUser,
  useGetOnboardingUser,
  useSearchOnboardingUser,
};
